import React, { useEffect, useRef, useState } from 'react';
import { Field } from '@sitecore-jss/sitecore-jss-nextjs';
import { EmblaOptionsType } from 'embla-carousel';

import { JabraSlider, JabraSliderRef } from 'common/components/JabraSlider/JabraSlider';
import SliderCardWithPrice from 'components/Product/AccessorySpot/SliderCardWithPrice';
import { ProductCatalogProductWithPrice } from 'composables/Product/AccessorySpot/AccessorySpotTypes';

export type SliderProps = {
  id?: string;
  header: Field<string>;
  cards: ProductCatalogProductWithPrice[];
};

const SliderWithPrice = ({ header, cards }: SliderProps): React.ReactElement => {
  const [startIndex] = useState<number>(0);
  const sliderContainerRef = useRef<HTMLDivElement>(null);

  const jabraSlider = useRef<JabraSliderRef>(null);

  const sliderSettings: EmblaOptionsType = {
    containScroll: 'trimSnaps',
    loop: false,
    align: 'start',
  };

  const handleKeyDown = (event: KeyboardEvent) => {
    if (!jabraSlider.current) return;
    if (event.key === 'ArrowLeft') {
      jabraSlider.current.prev();
    } else if (event.key === 'ArrowRight') {
      jabraSlider.current.next();
    }
  };

  useEffect(() => {
    const ref = sliderContainerRef.current;
    if (ref) {
      ref.addEventListener('keydown', handleKeyDown);
      return () => {
        ref.removeEventListener('keydown', handleKeyDown);
      };
    }
    return undefined;
  }, []);

  return (
    <>
      {!!cards.length && (
        <div className="w-full">
          {header?.value && <h2 className="heading-2 mb-0 text-center">{header.value}</h2>}
          <div className="pb-6 pt-12" ref={sliderContainerRef}>
            <JabraSlider
              mainClassName="relative w-full focus:outline-none"
              footerClassName="flex w-full justify-end pt-4"
              startIndex={startIndex}
              slideClassName="mr-2 md:mr-4"
              sliderSettings={sliderSettings}
              ref={jabraSlider}
              slideArrowsAlign="bottom"
              showSlideArrows={true}
              showSlideArrowsOnMobile={true}
              overflow={true}
              buttonVariant="secondary"
            >
              {cards.map((card) => (
                <SliderCardWithPrice key={card.sku} accessory={card} />
              ))}
            </JabraSlider>
          </div>
        </div>
      )}
    </>
  );
};

export default SliderWithPrice;
